<template>
  <div class="safedig-reset-page" v-loading.fullscreen.lock="loading">
    <SafeDigHeader />
    <div class="safedig-reset-main">
      <div class="safedig-reset-content">
        <div class="safedig-reset-card">
          <div class="safedig-reset-card-header">Reset Password</div>
          <div class="safedig-reset-card-body">
            <p class="safedig-reset-instruction">
              Enter your new password below to complete your password reset.
            </p>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)" class="safedig-reset-form">
                <div class="safedig-form-group">
                  <label class="safedig-label">New Password</label>
                  <base-input
                    alternative
                    type="password"
                    class="safedig-input-wrap"
                    name="New password"
                    :rules="{ required: true }"
                    placeholder="New Password"
                    v-model="form.newpassword"
                  />
                </div>

                <div class="safedig-form-group">
                  <label class="safedig-label">Confirm Password</label>
                  <base-input
                    alternative
                    type="password"
                    class="safedig-input-wrap"
                    name="Confirm password"
                    :rules="{ required: true }"
                    placeholder="Confirm Password"
                    v-model="form.confirmpassword"
                  />
                </div>

                <base-button native-type="submit" class="safedig-submit-btn">
                  Submit
                </base-button>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>

    <div class="siteFooter footerOffWhite safedigFooter safedigResetFooter">
      <div class="safedigCustomFooter">
        <div>
          <img
            src="../../../assets/safe-dig/safedig_logo_grayscale-01.png"
            class="safedigindiana811Logo"
            alt="Safe Dig Indiana"
          />
        </div>
        <p class="copyright">
          {{ $t('footer.copyright', { year }) }}<br>
          {{ $t('footer.allRightsReserved') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import SafeDigHeader from '@/components/safe-dig/Header.vue';

export default {
  name: 'SafeDigResetPassword',
  components: {
    SafeDigHeader
  },
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      form: {
        newpassword: '',
        confirmpassword: '',
        link: ''
      }
    };
  },
  created() {
    if (this.$route.query.link) {
      this.form.link = this.$route.query.link;
    }
  },
  methods: {
    onSubmit() {
      if (this.form.newpassword !== this.form.confirmpassword) {
        Swal.fire({
          text: "Password didn't match!",
          icon: 'error',
          confirmButtonClass: 'btn btn-success btn-fill'
        });
        return;
      }

      this.loading = true;
      this.$http
        .post('user/resetPassword', {
          link: this.form.link,
          new_password: this.form.newpassword
        })
        .then(() => {
          this.$router.push('/login');
          Swal.fire({
            text: 'Password updated successfully. You can now login.',
            icon: 'success',
            confirmButtonClass: 'btn btn-success btn-fill'
          });
        })
        .catch(() => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong! Please try again.',
            icon: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.safedig-reset-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.safedig-reset-main {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 32px 16px 48px;
}

.safedig-reset-content {
  width: 100%;
  max-width: 530px;
}

.safedig-reset-card {
  width: 100%;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border: 1px solid #b8c2cc;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
}

.safedig-reset-card-header {
  background: #3e7799;
  color: #fff;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: 700;
}

.safedig-reset-card-body {
  padding: 16px 15px 18px;
}

.safedig-reset-instruction {
  margin: 0 0 16px;
  font-size: 16px;
  color: #3d4852;
  line-height: 1.5;
}

.safedig-reset-form {
  margin: 0;
}

.safedig-form-group {
  margin-bottom: 12px;
}

.safedig-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
}

.safedig-reset-page >>> .input-group-alternative {
  box-shadow: none;
}

.safedig-input-wrap >>> .form-control {
  height: 44px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background: #fff;
  padding: 12px 16px;
}

.safedig-submit-btn {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  background: #9c3c21 !important;
  border: none !important;
  border-radius: 4px !important;
  color: #fff !important;
}

.safedig-submit-btn:hover {
  background: #85341c !important;
  color: #fff !important;
}

.siteFooter {
  width: 100%;
}

.safedigFooter {
  background: #e8e8e8;
}

.safedigResetFooter .safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.safedigindiana811Logo {
  height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 14px;
  line-height: 1.5;
}
</style>
